const downloadFile = (blob: any, name: string, skipPreview: boolean = false) => {
    if (name.endsWith('.pdf') && !skipPreview) {
        // @ts-ignore
        window.openPdfPreview(blob, name);
        return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = window.document.createElement('a');

    link.href = url;
    link.setAttribute('download', name);

    window.document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
};

export { downloadFile };
